<template>
    <div class="vue-garage-select" :class="{'error': hasError}">
        <v-select
            v-model="selectedGarage"
            @input="handleInput"
            @search="handleSearch"
            :options="garages"
            :filterable="false"
            placeholder="Zoek op postcode of plaats"
            label="name"
            :loading="loading"
        >
            <template slot="option" slot-scope="option">
                {{ option.name }} <span style="font-style: italic;">({{ option.distance | formatDistance }})</span>
            </template>

            <template #no-options="{ search, searching, loading }">
                Vul a.u.b. een geldige postcode of plaatsnaam in.
            </template>
        </v-select>
    </div>
</template>

<script>
export default {
    name: "GarageSelect",

    props: ['initialSelected', 'inputClasses'],

    data() {
        return {
            garages: [],
            selectedGarage: null,
            searchValue: '',
            loading: false,
        }
    },

    computed: {
        hasError() {
            return this.inputClasses.includes('error');
        }
    },

    filters: {
        formatDistance(value) {
            return `${value.toFixed(2)} km`;
        }
    },

    created() {
        this.fetchGarages()
            .finally(() => {
                if (_.isEmpty(this.initialSelected)) {
                    return;
                }

                this.selectedGarage = _.find(this.garages, (garage) => {
                    return garage.id === this.initialSelected
                });
            });
    },

    methods: {
        async fetchGarages() {
            let url = `/api/garages-by-geo`
            let currentLanguage = window.drupalSettings.ef2_custom.lang_code

            if (currentLanguage && currentLanguage !== 'nl') {
                url = `/${currentLanguage}/api/garages-by-geo`
            }

            url += `?searchQuery=${this.searchValue}`

            await axios.get(url)
                .then(response => {
                    if (!lodash.isNil(response.data.message)) {
                        this.garages = [];
                        return;
                    }

                    this.garages = response.data;
                })
                .catch(error => {
                   this.garages = [];
                })
                .finally(() => this.loading = false);
        },

        handleInput(payload) {
            let webformElement = document.querySelector('.carprof-garage-select-element input.webform-garage-select-element');
            let webformElementGarageName = document.querySelector('input[name="garage_name"]');

            this.loading = false;

            if (_.isEmpty(payload)) {
                webformElement.value = '';
                webformElementGarageName.value = '';
                return;
            }

            webformElement.value = payload.id;
            webformElementGarageName.value = payload.name;
        },

        handleSearch(payload) {
            this.loading = true;
            this.searchValue = payload;

            if (_.isEmpty(payload)) {
                this.loading = false;
                return;
            }

            this.setSearchValue();
        },

        setSearchValue: _.debounce(function() {
            this.fetchGarages();
        }, 500),
    }
}
</script>